import type { SkillRequestModel } from 'ab-requestModels/skill.requestModel';

import { isValidTextInput } from '@acceligentllc/shared/utils/text';

export function validate(values: SkillRequestModel) {
	const errors: ValidationErrors = {};

	if (!isValidTextInput(values.name)) {
		errors.name = 'Name is required';
	}

	if (!values.color) {
		errors.color = 'Color is required';
	}

	return errors;
}
